import React from 'react';

import { employerProfilesUrl } from 'buyside/util/urlHelper';

import styles from './tagsStyles';

const { employerProfileTagGroups } = require('buyside/util/constantsFromRails.json');

const Tags = ({ fundProfile }) => {
  const groups = employerProfileTagGroups.map(tagGroup => {
    let includedTags = [];
    tagGroup.subgroups.forEach(subgroup => {
      includedTags = includedTags.concat(
        subgroup.tags.filter(({ name }) => fundProfile.tagNames.includes(name))
      );
    });
    return { label: tagGroup.name, tags: includedTags };
  });
  return (
    <ul className={styles.tagsSectionsList}>
      {groups.map((group, idx) => {
        const { label, tags } = group;
        return (
          <li key={idx}>
            <h4>{label}</h4>
            <div className={styles.tagsList}>
              {tags.map(({ id, name }, subIdx) => (
                <a
                  href={`${employerProfilesUrl()}?${encodeURI(`fund_tags[]=${id}`)}`}
                  key={subIdx}
                  className={styles.tag}
                >
                  {name}
                </a>
              ))}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default Tags;
